import React from "react";
import {
    createStyles,
    makeStyles,
    Theme,
    ThemeProvider,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import theme from "js/material-ui-theme";
import { useMediaQuery, createTheme, Input, LinearProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { ListSelectModal, ModalItem } from "./ListSelectModal";




export type ListItemSelectDialogProps = {
    state: boolean;
    loading?: boolean
    items?: ModalItem[];
    selectItem: (id: string) => void
    handleState: (open: boolean) => void
    searchText: string
    onSearchText: (text: string) => void
    OnRowsScrollEnd: () => void
    onClear?: () => void
    hasMoreValue: boolean
    isFetching?: boolean
};
export const ListItemSelectDialog = (props: ListItemSelectDialogProps) => {
    const { t } = useTranslation(["common"]);

    const isSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const classes = useStyles();


    return (
        <ThemeProvider theme={isSmallScreen ? themeForMobile : createTheme({
            ...theme,
            overrides: {
                MuiInput: {
                    underline: {
                        '&:after': {
                            color: 'rgba(0,0,0,0.87)',
                        },
                    }
                }
            }
        })}>
            <div>
                <Dialog
                    open={props.state}
                    onClose={() => {
                        props.handleState(false);
                        props.onSearchText('');
                    }}
                    maxWidth="sm"
                    fullWidth={true}
                    fullScreen={isSmallScreen}
                >
                    <div className={classes.header}>
                        <Input
                            className={classes.root}
                            placeholder={t('search')}
                            onChange={(e) => { props.onSearchText(e.target.value); }}
                        />

                        <Button
                            className={classes.closeButton}
                            onClick={() => {
                                props.handleState(false);
                                props.onSearchText('');
                            }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    {props.loading && <LinearProgress color="primary" style={{ height: 15 }} />}
                    <DialogContent style={{ minHeight: 600 }}>
                        {
                            <ListSelectModal
                                OnRowsScrollEnd={props.OnRowsScrollEnd}
                                hasMoreValue={props.hasMoreValue}
                                items={props.items}
                                searchText={props.searchText}
                                onSelect={(id) => {
                                    props.selectItem(id);
                                    props.handleState(false);
                                    // props.onSearchText('');
                                }}
                            />
                        }
                    </DialogContent>
                    <DialogActions
                        className={isSmallScreen ? classes.footer : ''}
                    >
                        <Button
                            onClick={() => {
                                props.handleState(false);
                                props.onSearchText('');
                            }}
                            color="default"
                        >
                            {t('cancel').toUpperCase()}
                        </Button>

                        <Button
                            onClick={() => {
                                props.onClear()
                                props.onSearchText('');
                                props.handleState(false);
                            }}
                            color="default"
                        >
                            {t('clear').toUpperCase()}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </ThemeProvider>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            fontSize: "16px",
            paddingTop: "10px",
            paddingLeft: "8px",
            marginBottom: '5px',
            flex: "12",
        },
        header: {
            display: "flex",
            backgroundColor: "#00897b",
        },
        closeButton: {
            color: "white",
            fontSize: "15px",
            flex: "auto",
        },
        footer: {
            width: '100%',
            position: 'absolute',
            bottom: '10px',
            left: 0,
            padding: 0,
        },
    })
);

const themeForMobile = createTheme({
    ...theme,
    overrides: {
        MuiDialog: {
            paperFullWidth: {
                width: '100%',
            },
            paperScrollPaper: {
                maxHeight: '100%',
                height: '100%',
            },
            paper: {
                margin: 0,
            }
        },
        MuiInput: {
            underline: {
                '&:after': {
                    color: 'rgba(0,0,0,0.87)',
                },
            }
        }
    }
});